<template>
	<span class="el-breadcrumb__item">
		<span ref="link" :class="['el-breadcrumb__inner', to ? 'is-link' : '']" role="link">
			<slot />
		</span>
		<i v-if="separatorClass" :class="separatorClass" class="el-breadcrumb__separator" />
		<span v-else class="el-breadcrumb__separator" role="presentation">{{ separator }}</span>
	</span>
</template>
<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'DmsBreadcrumbItem',

	inject: ['elBreadcrumb'],
	props: {
		to: Object,
		replace: Boolean,
	},
	data() {
		return {
			separator: '',
			separatorClass: '',
		};
	},

	mounted() {
		this.separator = this.elBreadcrumb.separator;
		this.separatorClass = this.elBreadcrumb.separatorClass;
		const { link } = this.$refs;
		link.setAttribute('role', 'link');
		link.addEventListener('click', () => {
			const { to } = this;
			if (!to) return;
			this.$emit('click', to);
		});
	},
});
</script>
